import { c as _c } from "react/compiler-runtime";
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import GoogleMapsLoader from '@/components/entities/utils/google-maps-loader';
type LatLng = {
  latitude: number;
  longitude: number;
};
const getCoordinatesFromAddress = async (address: string): Promise<LatLng> => {
  await GoogleMapsLoader.importLibrary('geocoding');
  const geocoder = new google.maps.Geocoder();
  const result = await geocoder.geocode({
    address
  });
  return {
    latitude: result.results[0].geometry.location.lat() || 0,
    longitude: result.results[0].geometry.location.lng() || 0
  };
};
const useInitializeStreetView = (address, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== address) {
    t0 = ["coordinates", address];
    t1 = () => getCoordinatesFromAddress(address);
    $[0] = address;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      ...options,
      queryKey: t0,
      queryFn: t1
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
export default useInitializeStreetView;